import { gql } from "@apollo/client";

export const DELETE_WORKSPACES = gql`
  mutation DeleteWorkspaces($input: DeleteWorkspacesInput!) {
    deleteWorkspaces(input: $input)
  }
`;
